import { getApiUrl, getAuthUrl } from '@podus/utils';

/**
 * Static app key NEW_PODUS_API's systemMiddleware checks on every route. It is an app identifier, not a
 * secret: it ships in every browser bundle (MIGRATION_PLAN.md section 2, item 2).
 */
const DEFAULT_SYSTEM_KEY = 'G@V3l2023-new-podus-v001233-SyS';

export interface PodusApiConfig {
    /** auth.podus.org, or a local auth app */
    authUrl?: string;
    /** NEW_PODUS_API root, with or without the trailing /api */
    apiUrl?: string;
    /** Replaces the built-in system key */
    systemKey?: string;
}

let config: PodusApiConfig = {};

/**
 * Each app calls this once at startup with its env overrides (`VITE_AUTH_URL`, `VITE_PODUS_API_URL`,
 * `VITE_PODUS_SYSTEM_KEY`). Anything left out resolves from `@podus/utils` at request time: localhost in
 * development, the production hosts otherwise.
 */
export function configurePodusApi(next: PodusApiConfig): void {
    config = { ...config, ...next };
}

export function authUrl(): string {
    return config.authUrl || getAuthUrl();
}

export function apiUrlSetting(): string {
    return config.apiUrl || getApiUrl();
}

export function systemKey(): string {
    return config.systemKey || DEFAULT_SYSTEM_KEY;
}
